<template>
    <article>
        <rooster-header title="Settings"></rooster-header>

        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" role="tab"  href="#account-tab-content"
                   id="account-tab" aria-controls="account-tab-content" aria-selected="true">Account</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#developer-tab-content" role="tab"
                   id="developer-tab"
                   aria-controls="developer-tab" aria-selected="false">Developer</a>
            </li>
        </ul>

        <div class="tab-content py-3">
            <div class="tab-pane fade show active" id="account-tab-content" role="tabpanel"
                 aria-labelledby="account-tab">
                <form action="" @submit.prevent="submit">
                    <div class="form-group">
                        <label for="inp-name">Name</label>
                        <input type="text" class="form-control" id="inp-name"
                               v-model="user.name"
                               :disabled="submitting"
                               placeholder="" />
                    </div>

                    <div class="form-group">
                        <label for="inp-email">Email address</label>
                        <input type="email" class="form-control" id="inp-email" aria-describedby="inp-email"
                               v-model="user.email" disabled
                               placeholder="Enter email" />
                        <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
                    </div>

                    <div class="form-group">
                        <label for="inp-timezone">Timezone</label>
                        <select v-model="user.timezone" id="inp-timezone" class="form-control"
                                :disabled="submitting"
                            >
                            <option v-for="z in timezones"
                                    v-bind:value="z"
                            >
                                {{z}}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="inp-clockout-on-offline" v-if="user">
                            <input type="checkbox" id="inp-clockout-on-offline" v-model="user.preferences.clockout_on_offline" />
                            Auto clock out when offline
                        </label>
                        <small class="form-text text-muted">Checking this will clock you out either when you specifically close the browser tab or you go offline for any reason.</small>
                    </div>

                    <button type="submit" class="btn btn-primary" :disabled="submitting">{{submitting ? "Applying.." : "Apply"}}</button>
                </form>
            </div>

            <div class="tab-pane fade" id="developer-tab-content" role="tabpanel" aria-labelledby="developer-tab">
                <p class="alert alert-info">Do you know what an API is? If not, this screen might not be for you.</p>

                <pass-personal-access-tokens></pass-personal-access-tokens>
                <pass-clients class="mt-3"></pass-clients>
            </div>
        </div>
    </article>
</template>

<script>
    Vue.component(
        'pass-clients',
        require('../passport/Clients.vue').default
    );

    Vue.component(
        'pass-authorized-clients',
        require('../passport/AuthorizedClients.vue').default
    );

    Vue.component(
        'pass-personal-access-tokens',
        require('../passport/PersonalAccessTokens.vue').default
    );

    export default {
        name: "Settings",
        props: [
            "timezones"
        ],

        data() {
            return {
                user: false,
                submitting: false,
                toastVisible: false
            }
        },

        mounted() {
            var that = this;
            window.axios.get("api/user")
                .then(function(resp){
                    that.user = Object.assign({}, resp.data.user);
                });
        },

        methods: {
            submit() {
                this.submitting = true;
                const that = this;
                window.axios.put("api/user", this.user)
                    .then(function(resp){
                        that.submitting = false;
                        that.toastVisible = true;
                        that.$emit("preferences-changed", resp.data.preferences);
                    })
                    .catch(function(err){
                        alert(err.message);
                    });
            }
        }
    }
</script>
